import { useQuery } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { Component } from 'types';

const getComponents = async (orgId: string, projectId?: string): Promise<Component[]> => {
  const params = new URLSearchParams({ orgId });
  if (projectId) {
    params.append('projectId', projectId);
  }
  const response = await customAxios.get<Component[]>(`/components?${params.toString()}`);
  return response.data;
};

export const useGetComponents = (orgId: string, projectId?: string) =>
  useQuery<Component[]>({
    queryKey: ['components', orgId, projectId],
    queryFn: () => getComponents(orgId, projectId),
    enabled: !!orgId,
  });
